import AddToCartFormik from '@jetshop/core/components/Mutation/AddToCartFormik';
import React, { useState } from 'react';
import { useNotification } from '@jetshop/core/components/Notifications';
import addToCartMutation from '../../Cart/queries/addToCart.gql';
import CartQuery from '../../Cart/queries/cartQuery.gql';
import ProductToastWrapper from './ProductToast';

const AddToCartForm = ({ children, product, variant, getMissingOptions }) => {
  const [addedToCart, setAdded] = useState(false);
  const [trigger, dismiss] = useNotification();

  const onAddToCartInit = ({ mutationId, quantity, price }) => {
    trigger(
      <ProductToastWrapper
        selectedVariation={variant}
        product={product}
        quantity={quantity}
        price={price}
      />,
      {
        id: mutationId,
        type: 'add-to-cart'
      }
    );
    //AFTER BUY CLICK SCROLL TO RELATED
    if (typeof document !== 'undefined') {
      const related = document.getElementById('related-products');
      if (related)
        related.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };
  const onAddToCartSuccess = data => {
    setAdded(true);
  };
  const onAddToCartError = () => {
    return ({ variant, mutationId, quantity, price, error }) => {
      dismiss(mutationId);
      trigger(
        <ProductToastWrapper
          selectedVariation={variant}
          product={product}
          quantity={quantity}
          price={price}
          error={error}
        />,
        {
          type: 'add-to-cart'
        }
      );
    };
  };
  return (
    <AddToCartFormik
      onAddToCartInit={onAddToCartInit}
      onAddToCartError={onAddToCartError}
      onAddToCartSuccess={onAddToCartSuccess}
      cartQuery={CartQuery}
      cartMutation={addToCartMutation}
      product={product}
      variant={variant}
      getMissingOptions={getMissingOptions}
    >
      {() => children(addedToCart, setAdded)}
    </AddToCartFormik>
  );
};

export default AddToCartForm;
